import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import Image from "./image";

import logoRitzCancun from "../../../static/images/logos/ritz-cancun.png";
import logoRitzKapalua from "../../../static/images/logos/ritz-kapalua.png";
import logoGrandHyattKauai from "../../../static/images/logos/grand-hyatt-kauai.png";
import logoFairmontKeaLani from "../../../static/images/logos/fairmont-kea-lani.png";
import calloutMaui from "../../../static/images/trip-maui-destination-callout.jpg";
import calloutMaui2019 from "../../../static/images/trip-maui2019-destination-callout.jpg";
import calloutMaui2021 from "../../../static/images/trip-maui2021-destination-callout.jpg";
import calloutCancun from "../../../static/images/trip-cancun-destination-callout.jpg";
import calloutCancun2020 from "../../../static/images/trip-cancun2020-destination-callout.jpg";
import calloutCancun2021 from "../../../static/images/trip-cancun2021-destination-callout.jpg";
import calloutKauai2019 from "../../../static/images/trip-kauai2019-destination-callout.jpg";
import calloutKauai2021 from "../../../static/images/trip-kauai2021-destination-callout.jpg";

const images = {
  "ritz-cancun": logoRitzCancun,
  "ritz-kapalua": logoRitzKapalua,
  "grand-hyatt-kauai": logoGrandHyattKauai,
  "fairmont-kea-lani": logoFairmontKeaLani,
  "callout-maui": calloutMaui,
  "callout-maui2019": calloutMaui2019,
  "callout-maui2021": calloutMaui2021,
  "callout-cancun": calloutCancun,
  "callout-cancun2020": calloutCancun2020,
  "callout-cancun2021": calloutCancun2021,
  "callout-kauai2019": calloutKauai2019,
  "callout-kauai2021": calloutKauai2021,
};
const { siteMetadata: config } = GatsbyConfig;

export default class DestinationCallout extends React.Component {
  render() {
    const { trip } = this.props;
    const tripData = config.trips[trip];
    const venueLogo = (
      <div className="venue-logo">
        <Image src={images[tripData.venueSlug]} alt={tripData.venue} />
      </div>
    );

    return (
      <div className="destination-callout">
        <div className="wrap">
          <Image src={images[`callout-${trip}`]} alt="" />
          <h2>Destination & Resort</h2>
          {
            {
              maui: (
                <div className="destination-callout-body">
                  <p>
                    From its heavenly beaches, tumbling waterfalls, romantic
                    sunsets, and scenic natural wonders, there are plenty of
                    reasons why Maui consistently tops travel magazine reader
                    polls as the most romantic island in the world. Maui has a
                    little bit of something for everyone; secluded sandy
                    beaches, lush tropical rainforests, aqua blue ocean water
                    with rich marine life, and more. Your vacation on the
                    “Valley Isle” promises to be a memorable one!
                  </p>
                  <p>
                    The Ritz-Carlton, Kapalua is among Hawaii’s most
                    breathtaking resorts. This oceanfront hotel introduces
                    travelers to the culture and natural beauty of Maui while
                    pampering them with luxurious amenities including a locally
                    inspired spa, two world-renowned golf courses, six
                    restaurants, and boundless outdoor activities that highlight
                    the surrounding natural beauty.
                  </p>
                  {venueLogo}
                </div>
              ),
              cancun: (
                <div className="destination-callout-body">
                  <p>
                    With its white sand beaches, aqua-blue waters, spectacular
                    cenotés, and historic Mayan ruins, Cancun, Mexico, is a
                    favorite tropical destination with world travelers and the
                    perfect location for a romantic getaway!
                  </p>
                  <p>
                    The Ritz-Carlton, Cancun offers guests a truly luxurious
                    experience with an impeccable level of service. The resort
                    is set along one of the finest beaches in Mexico and
                    embodies the vibrant charm of this beach town. The
                    Ritz-Carlton, Cancun is consistently ranked among the finest
                    resorts in the world and today it is proudly known as
                    Mexico’s most awarded resort.
                  </p>
                  {venueLogo}
                </div>
              ),
              cancun2020: (
                <div className="destination-callout-body">
                  <p>
                    With its white-sand beaches, aqua-blue waters, spectacular
                    cenotés, and historic Mayan ruins, Cancun, Mexico, is a
                    favorite tropical destination with world travelers and the
                    perfect location for a romantic getaway!
                  </p>
                  <p>
                    The Ritz-Carlton, Cancun offers guests a truly luxurious
                    experience with an impeccable level of service. The resort
                    is set along one of the finest beaches in Mexico and
                    embodies the vibrant charm of this beach town. The
                    Ritz-Carlton, Cancun is consistently ranked among the finest
                    resorts in the world and today it is proudly known as
                    Mexico’s most awarded resort.
                  </p>
                  {venueLogo}
                </div>
              ),
              cancun2021: (
                <div className="destination-callout-body">
                  <p>
                    With its white-sand beaches, aqua-blue waters, spectacular
                    cenotés, and historic Mayan ruins, Cancun, Mexico, is a
                    favorite tropical destination with world travelers and the
                    perfect location for a romantic getaway!
                  </p>
                  <p>
                    The Ritz-Carlton, Cancun offers guests a truly luxurious
                    experience with an impeccable level of service. The resort
                    is set along one of the finest beaches in Mexico and
                    embodies the vibrant charm of this beach town. The
                    Ritz-Carlton, Cancun is consistently ranked among the finest
                    resorts in the world and today it is proudly known as
                    Mexico’s most awarded resort.
                  </p>
                  {venueLogo}
                </div>
              ),
              maui2019: (
                <div className="destination-callout-body">
                  <p>
                    From its heavenly beaches, tumbling waterfalls, romantic
                    sunsets, and scenic natural wonders, there are plenty of
                    reasons why Maui consistently tops travel magazine reader
                    polls as the most romantic island in the world. Maui has a
                    little bit of something for everyone; secluded sandy
                    beaches, lush tropical rainforests, aqua blue ocean water
                    with rich marine life, and more. Your vacation on the
                    “Valley Isle” promises to be a memorable one!
                  </p>
                  <p>
                    The Ritz-Carlton, Kapalua is among Hawaii’s most
                    breathtaking resorts. This oceanfront hotel introduces
                    travelers to the culture and natural beauty of Maui while
                    pampering them with luxurious amenities including a locally
                    inspired spa, two world-renowned golf courses, six
                    restaurants, and boundless outdoor activities that highlight
                    the surrounding natural beauty.
                  </p>
                  {venueLogo}
                </div>
              ),
              kauai2019: (
                <div className="destination-callout-body">
                  <p>
                    From the soaring cliffs of the Napali Coast to the vast
                    chasms of Waimea Canyon, Kauai enchants the senses like no
                    other destination in the world! Unwind as you kayak down
                    Kauai’s Wailua River or breathe deeply at the edge of a
                    cliffside overlooking the deep blue ocean below. From the
                    small towns of Hanalei and Old Koloa Town to sunny Poipu
                    Beach, this is truly “Hawaii’s Island of Discovery”.
                  </p>
                  <p>
                    If you are in search of a resort that truly “has it all”,
                    look no further! Poipu’s 602-room Grand Hyatt Kauai offers
                    an array of amenities: five acres of pools, the 40,000 sqft
                    Anara Spa, enchanting manicured gardens, an award winning
                    18-hole golf course, 11 restaurants, and 13 shops. This
                    remarkable resort is set between magnificent lush mountains
                    and the azure aqua blue sea. The Grand Hyatt Kauai is the
                    perfect base for your discovery of the wonders of the
                    picturesque “Garden Isle”.
                  </p>
                  {venueLogo}
                </div>
              ),
              kauai2021: (
                <div className="destination-callout-body">
                  <p>
                    From the soaring cliffs of the Napali Coast to the vast
                    chasms of Waimea Canyon, Kauai enchants the senses like no
                    other destination in the world! Unwind as you kayak down
                    Kauai’s Wailua River or breathe deeply at the edge of a
                    cliffside overlooking the deep blue ocean below. From the
                    small towns of Hanalei and Old Koloa Town to sunny Poipu
                    Beach, this is truly “Hawaii’s Island of Discovery”.
                  </p>
                  <p>
                    If you are in search of a resort that truly “has it all”,
                    look no further! Poipu’s 602-room Grand Hyatt Kauai offers
                    an array of amenities: five acres of pools, the 40,000 sqft
                    Anara Spa, enchanting manicured gardens, an award winning
                    18-hole golf course, 11 restaurants, and 13 shops. This
                    remarkable resort is set between magnificent lush mountains
                    and the azure aqua blue sea. The Grand Hyatt Kauai is the
                    perfect base for your discovery of the wonders of the
                    picturesque “Garden Isle”.
                  </p>
                  {venueLogo}
                </div>
              ),
              maui2021: (
                <div className="destination-callout-body">
                  <p>
                    Discover the essence of Maui at Fairmont Kea Lani, Hawaii’s
                    only all-suite and villa luxury resort. Nestled on the soft
                    white sands of Wailea’s Polo Beach, this award-winning
                    oceanfront paradise redefines luxury with a state-of-the-art
                    spa, island inspired cuisine and authentic cultural
                    experiences.
                  </p>
                  <p>
                    Fairmont Kea Lani is the ideal island getaway with six
                    dining venues, three swimming pools, a
                    comprehensive fitness and wellness program, and unrivaled
                    access to the best adventures across the island. Aloha
                    awaits!
                  </p>
                  {venueLogo}
                </div>
              ),
            }[trip]
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/destination-callout.js